import CustomerDashboard from './CustomerDashboard';

export default CustomerDashboard;
